module.exports = __webpack_public_path__ + "b287fb94876aa4551b798896885811f6.png";